import React, { useReducer } from 'react';
import {Button, Card, CardBody} from "reactstrap";
import {useEntity} from "react-admin-base";
import {EntityEditor} from 'react-admin-base-bootstrap';
import {Breadcrumb} from 'react-admin-base-nazox';
import UserInfoInput from '../../Components/UserInfoInput';
import { PaymentModal } from '../../Components/PaymentMethods/PayNow';

export default function Edit() {
    const entity = useEntity('/user', 'me');
    const [data, setData] = entity;
    
    const [ enabled, setEnabled ] = useReducer(a => !a, false); 

    return <>
        <Breadcrumb
            title="My Profile"
            data={
                [
                    {
                        href: '/profil',
                        name: 'My Profile'
                    }
                ]
            }
        />
        
        { enabled && <PaymentModal amount={40} onClose={setEnabled} />}
        <Button type="button" color="primary" className="mb-2" onClick={setEnabled}>Payment Test</Button>
        
        
        
        <EntityEditor entity={entity}>
            <Card>
                <CardBody>
                    <UserInfoInput
                        data={data}
                        setData={setData}
                        required
                    />
                </CardBody>
            </Card>
        </EntityEditor>
    </>;
}
